// src/utils/streakStatus.js

/** Chave de data "YYYY-MM-DD" no fuso America/Sao_Paulo. */
export function spDateKey(date = new Date()) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Sao_Paulo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

/** Hoje "YYYY-MM-DD" (SP). */
export function todayKeySP() {
  return spDateKey(new Date());
}

/** Mês atual "YYYY-MM" (SP). */
export function currentMonthKeySP() {
  return todayKeySP().slice(0, 7);
}

/** Soma `delta` dias a uma chave "YYYY-MM-DD" (âncora UTC-meio-dia, robusto). */
export function addDaysKey(dateKey, delta) {
  const d = new Date(`${dateKey}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + delta);
  return d.toISOString().slice(0, 10);
}

/** Ontem "YYYY-MM-DD" (SP). */
export function yesterdayKeySP() {
  return addDaysKey(todayKeySP(), -1);
}

/**
 * Quantos dias inteiros se passaram desde dateStr até hoje (fuso SP).
 * Ex.: dateStr = ontem → 1; anteontem → 2. Sem data → Infinity.
 * @param {string|null|undefined} dateStr  "YYYY-MM-DD"
 * @returns {number}
 */
export function daysSinceDateSP(dateStr) {
  if (!dateStr) return Infinity;
  const sp = (d) => new Date(d.toLocaleString("en-US", { timeZone: "America/Sao_Paulo" }));
  const today = sp(new Date());
  const last = sp(new Date(`${dateStr}T00:00:00`));
  return Math.floor((today - last) / 86400000);
}

/**
 * Streak "quebrado" = a última atividade registrada foi há 2 ou mais dias
 * (no fuso America/Sao_Paulo).
 *
 * Ex.: última atividade = segunda, hoje = quinta → 3 dias sem defender → quebrado.
 *      última atividade = ontem → ativo.
 *
 * @param {string|null|undefined} lastDateStr  data "YYYY-MM-DD" da última atividade
 *   (campo XP_VITA.LAST_ACTIVITY_DATE)
 * @returns {boolean} true se o streak está quebrado (fogo apagado)
 */
export function isStreakBroken(lastDateStr) {
  if (!lastDateStr) return true;
  return daysSinceDateSP(lastDateStr) >= 2;
}

export default isStreakBroken;
